import DrawerPreviousNext from "components/form/DrawerPreviousNext";
import DrawerCancelNext from "components/form/DrawerCancelNext";
import DrawerPreviousSubmit from "components/form/DrawerPreviousSubmit";
import Error from "components/form/Error";
import SelectCityAll from "components/form/SelectCityAll";
import InputArea from "components/form/InputArea";
import LabelArea from "components/form/LabelArea";
import InputValue from "components/form/InputValue";
import Title from "components/form/Title";
import React, { useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import ActiveButton from "components/form/ActiveButton";
import ImageandFileUploader from "components/image-uploader/ImageandFileUploader";
import SelectStateSingle from "components/form/SelectStateSingle";
import SelectState from "components/form/SelectStaffState";
import SelectCity from "components/form/SelectCity";
import InputMobileWoCode from "components/form/InputMobileWoCode";
import { FiX } from "react-icons/fi";
import InputName from "components/form/InputName";
import useFranchiseSubmit from "hooks/useFranchiseSubmit";
import { IoIosClose } from "react-icons/io";
import FranchiseSelectCity from "components/form/FranchiseSelectCities";
import SelectCityWithState from "components/form/SelectCityWithState";

const FranchiseDrawer = ({ id, onModalOpen }) => {
  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    handleNextStep,
    handlePreviousStep,
    errors,
    goToStep,
    step,
    idProofUrl,
    setIDProofUrl,
    panUrl,
    setPanUrl,
    gstUrl,
    setGstUrl,
    checkLeafUrl,
    setCheckLeafUrl,
    selectedCompanyValue,
    selectedProof,
    selectedCountryCode,
    handleChangeCompany,
    handleChangeProof,
    handleCityChange,
    handleStateChange,
    selectedCities,
    setSelectedCities,
    selectedServiceState,
    setSelectedServiceState,
    selectedServices,
    registrationDocumentUrl,
    setRegistrationDocumentUrl,
    agreementPdfUrl,
    setAgreementPdfUrl,

    loading,
    handleServiceStateChange,
    selectedState,
    setSelectedState,
    selectedCity,
    setSelectedCity,
  } = useFranchiseSubmit(id, onModalOpen);
  const handleCancelImage = (id) => {
    if (id === "proof") {
      setIDProofUrl("");
    } else if (id === "pan") {
      setPanUrl("");
    } else if (id === "agreement") {
      setAgreementPdfUrl("");
    } else if (id === "registration") {
      setRegistrationDocumentUrl("");
    } else if (id === "gst") {
      setGstUrl("");
    } else if (id === "check") {
      setCheckLeafUrl("");
    }
  };
  const tabs = [
    { tabValue: 1, labelName: "Basic Details" },
    // {
    //   tabValue: 2,
    //   labelName: "Company Details",
    // },
    { tabValue: 2, labelName: "ID Proof Details" },
    { tabValue: 3, labelName: "PAN & GST Details" },
    { tabValue: 4, labelName: "Bank Details" },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const openZoomModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeZoomModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const isPdfFile = (filePath) => {
    return filePath?.toLowerCase().endsWith(".pdf");
  };

  const isImageFile = (filePath) => {
    return /\.(jpg|jpeg|png)$/i.test(filePath);
  };
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2147483647,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
          }}
        >
          <div className="bg-white dark:bg-gray-800 rounded-lg px-8 py-6 shadow-xl flex flex-col items-center">
            <div className="" />

            <p className="text-lg font-semibold text-gray-800 dark:text-white">
              Please wait...
            </p>

            <p className="text-sm text-gray-500 dark:text-gray-300 mt-1">
              Processing your request
            </p>
          </div>
        </div>
      )}

      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title title={"Edit Franchise"} />
        ) : (
          <Title title={"Add Franchise"} />
        )}
      </div>
      <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-400">
        <ul className="flex flex-wrap -mb-px">
          {tabs.map(({ tabValue, labelName, condition = true }) =>
            condition ? (
              <li key={tabValue}>
                <ActiveButton
                  tabValue={tabValue}
                  labelName={labelName}
                  goToStep={goToStep}
                  step={step}
                />
              </li>
            ) : null,
          )}
        </ul>
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 scrollbar-hide flex-grow w-full h-full max-h-full pb-40 md:pb-32 lg:pb-32 xl:pb-32">
            {step === 1 && (
              <>
                <div className="grid grid-cols-12 gap-4 mb-6">
                  <div className="col-span-6">
                    <LabelArea required label={"Company Name"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Company Name"
                      name="company_name"
                      // minLength={10}
                      type="text"
                      placeholder={"xyz company"}
                    />
                    <Error errorName={errors.company_name} />
                  </div>
                  <div className="col-span-6">
                    <LabelArea required label={"Contact Person"} />
                    <InputName
                      trigger={trigger}
                      register={register}
                      label="Full Name"
                      name="owner_name"
                      type="text"
                      placeholder={"Jhon"}
                      minLength={3}
                      pattern={/^[a-zA-Z\s]+$/}
                    />
                    <Error errorName={errors.owner_name} />
                  </div>

                  {/* <div className="col-span-6">
                    <LabelArea required label={"State"} />
                    <SelectStateSingle
                      register={register}
                      label="State"
                      name="state"
                      selectedCountryId={110}
                      selectedState={selectedState}
                      handleStateChange={handleStateChange}
                    />
                    <Error errorName={errors.state} />
                  </div> */}

                  <div className="col-span-12">
                    <SelectCityWithState
                      selectedState={selectedState}
                      setSelectedState={setSelectedState}
                      selectedCity={selectedCity}
                      setSelectedCity={setSelectedCity}
                      errors={{
                        state: errors.state,
                        city: errors.city,
                      }}
                    />
                  </div>

                  {/* <div className="col-span-6">
                    <LabelArea required label={"City"} />
                    <SelectCityAll
                      register={register}
                      label="City"
                      name="city"
                      selectedState={selectedState}
                      selectedCity={selectedCity}
                      handleCityChange={handleCityChange}
                    />
                    <Error errorName={errors.city} />
                  </div> */}
                  <div className="col-span-6">
                    <LabelArea required label="Address" />

                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Address"
                      name="address"
                      type="text"
                      placeholder="Enter Address"
                    />
                    <Error errorName={errors.address} />
                  </div>
                  <div className="col-span-6">
                    <LabelArea required label={"Pincode"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Pincode"
                      name="pincode"
                      type="number"
                      maxLength={6}
                      placeholder={"604303"}
                      pattern={/^\d{6}$|^\d{3}\s\d{3}$/}
                    />
                    <Error errorName={errors.pincode} />
                  </div>
                  <div className="col-span-6">
                    <LabelArea required label={"Email"} />
                    <InputValue
                      trigger={trigger}
                      register={register}
                      label="Email"
                      name="email_id"
                      type="text"
                      placeholder={"jhon@gmail.com"}
                      pattern={
                        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
                      }
                    />
                    <Error errorName={errors.email_id} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"Contact Number"} />
                    <InputMobileWoCode
                      trigger={trigger}
                      register={register}
                      label="Mobile Number"
                      name="phone_no"
                      type="number"
                      minLength={10}
                      maxLength={10}
                      placeholder="9887564789"
                      pattern={/^\d{10}$/}
                      CountryCode={selectedCountryCode}
                      CountryCodeName="call_prefix"
                    />
                    <Error errorName={errors.phone_no} />
                  </div>

                  {/* <div className="col-span-6">
                    <LabelArea label={"Alternate Contact Number (Optional)"} />
                    <InputMobileWoCode
                      trigger={trigger}
                      register={register}
                      required={false}
                      label="Alternate Contact Number"
                      name="al_contact_no"
                      type="number"
                      minLength={10}
                      maxLength={10}
                      placeholder="9992787897"
                      pattern={/^\d{10}$/}
                      CountryCode={selectedCountryCode}
                      CountryCodeName="al_call_prefix"
                    />
                    <Error errorName={errors.al_contact_no} />
                  </div> */}

                  <div className="col-span-6">
                    <LabelArea required label="Select Service State" />
                    <SelectState
                      onSelectState={handleServiceStateChange}
                      register={register}
                      name="service_state"
                      required={false}
                      selectedServiceState={selectedServiceState}
                      setSelectedServiceState={setSelectedServiceState}
                    />
                    <Error errorName={errors.service_state} />
                  </div>

                  <div className="col-span-6">
                    {/* <LabelArea required label="Select Service City" /> */}
                    {/* <SelectCity
                      name="service_city"
                      selectedCities={selectedCities}
                      selectedStates={selectedServiceState}
                      setSelectedCities={setSelectedCities}
                      selectedAllCityinState={selectedServiceState}
                      onSelectedAllStates={selectedServiceState}
                      onChange={setSelectedCities}
                    /> */}

                    <FranchiseSelectCity
                      name="service_city"
                      label="Select Service City"
                      selectedCities={selectedCities}
                      selectedStates={selectedServiceState}
                      setSelectedCities={setSelectedCities}
                      onChange={setSelectedCities}
                      id={id}
                      loading={loading}
                    />

                    <Error errorName={errors.service_city} />
                  </div>
                  {id && (
                    <div className="col-span-6">
                      <LabelArea required label={"Password"} />
                      <InputArea
                        trigger={trigger}
                        register={register}
                        label="Password"
                        name="password"
                        placeholder={"Enter Password"}
                        type="text"
                        maxLength={120}
                      />
                      <Error errorName={errors.password} />
                    </div>
                  )}
                </div>

                <DrawerCancelNext handleNextStep={handleNextStep} />
              </>
            )}

            {step === 2 && (
              <>
                <div className="grid grid-cols-12 gap-4 mb-6">
                  {/* Registration Document */}
                  <div className="col-span-12">
                    <LabelArea required label="Registration Document" />

                    {registrationDocumentUrl ? (
                      <div className="flex items-center gap-3">
                        {isPdfFile(registrationDocumentUrl) ? (
                          <a
                            href={
                              process.env.REACT_APP_API_IMAGE_URL +
                              registrationDocumentUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-4 py-3 border rounded-md text-blue-600 hover:bg-blue-50"
                          >
                            📄 View Registration PDF
                          </a>
                        ) : isImageFile(registrationDocumentUrl) ? (
                          <img
                            src={
                              process.env.REACT_APP_API_IMAGE_URL +
                              registrationDocumentUrl
                            }
                            alt="Registration Document"
                            className="w-40 h-28 rounded-lg object-cover cursor-pointer"
                            onClick={() =>
                              openZoomModal(
                                process.env.REACT_APP_API_IMAGE_URL +
                                  registrationDocumentUrl,
                              )
                            }
                          />
                        ) : (
                          <a
                            href={
                              process.env.REACT_APP_API_IMAGE_URL +
                              registrationDocumentUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline"
                          >
                            📎 View File
                          </a>
                        )}

                        <FiX
                          size={22}
                          className="cursor-pointer"
                          onClick={() => setRegistrationDocumentUrl("")}
                        />
                      </div>
                    ) : (
                      <ImageandFileUploader
                        is_multiple={false}
                        folder="franchise_registeration"
                        name_merge="FRANCHISE_REGISTRATION"
                        imageUrl={registrationDocumentUrl}
                        setImageUrl={setRegistrationDocumentUrl}
                        no_of_image={1}
                        acceptType="application/pdf, image/jpeg, image/jpg, image/png"
                      />
                    )}

                    <Error errorName={errors.registration_document_img} />
                  </div>

                  {/* Agreement PDF */}
                  <div className="col-span-12">
                    <LabelArea required label="Agreement PDF" />

                    {agreementPdfUrl ? (
                      <div className="flex items-center gap-3">
                        {isPdfFile(agreementPdfUrl) ? (
                          <a
                            href={
                              process.env.REACT_APP_API_IMAGE_URL +
                              agreementPdfUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-4 py-3 border rounded-md text-blue-600 hover:bg-blue-50"
                          >
                            📄 View Agreement PDF
                          </a>
                        ) : isImageFile(agreementPdfUrl) ? (
                          <img
                            src={
                              process.env.REACT_APP_API_IMAGE_URL +
                              agreementPdfUrl
                            }
                            alt="Agreement"
                            className="w-40 h-28 rounded-lg object-cover cursor-pointer"
                            onClick={() =>
                              openZoomModal(
                                process.env.REACT_APP_API_IMAGE_URL +
                                  agreementPdfUrl,
                              )
                            }
                          />
                        ) : (
                          <a
                            href={
                              process.env.REACT_APP_API_IMAGE_URL +
                              agreementPdfUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline"
                          >
                            📎 View File
                          </a>
                        )}

                        <FiX
                          size={22}
                          className="cursor-pointer"
                          onClick={() => setAgreementPdfUrl("")}
                        />
                      </div>
                    ) : (
                      <ImageandFileUploader
                        is_multiple={false}
                        folder="franchise_agreement"
                        name_merge="FRANCHISE_AGREEMENT"
                        imageUrl={agreementPdfUrl}
                        setImageUrl={setAgreementPdfUrl}
                        no_of_image={1}
                        acceptType="application/pdf, image/jpeg, image/jpg, image/png"
                      />
                    )}

                    <Error errorName={errors.agreement_pdf} />
                  </div>
                </div>

                <DrawerPreviousNext
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
              </>
            )}
            {step === 3 && (
              <>
                <div className="grid grid-cols-12 gap-4 mb-6">
                  <div className="col-span-6">
                    <LabelArea required label={"PAN Number"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="PAN Number"
                      name="pan_number"
                      type="text"
                      placeholder={"ABCTY1234D"}
                      capitalize={true}
                      pattern={/[A-Z]{5}[0-9]{4}[A-Z]{1}$/}
                    />
                    <Error errorName={errors.pan_number} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea required label={"PAN Card"} />

                    {panUrl ? (
                      <div className="flex items-center gap-3">
                        {isPdfFile(panUrl) ? (
                          <a
                            href={process.env.REACT_APP_API_IMAGE_URL + panUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-4 py-3 border rounded-md text-blue-600 hover:bg-blue-50"
                          >
                            📄 View PAN PDF
                          </a>
                        ) : isImageFile(panUrl) ? (
                          <img
                            style={{
                              objectFit: "cover",
                              width: "250px",
                              borderRadius: "10px",
                              height: "100px",
                              cursor: "pointer",
                            }}
                            src={process.env.REACT_APP_API_IMAGE_URL + panUrl}
                            alt="PAN Card"
                            onClick={() =>
                              openZoomModal(
                                process.env.REACT_APP_API_IMAGE_URL + panUrl,
                              )
                            }
                          />
                        ) : (
                          <a
                            href={process.env.REACT_APP_API_IMAGE_URL + panUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline"
                          >
                            📎 View File
                          </a>
                        )}

                        <FiX
                          size={25}
                          className="cursor-pointer"
                          onClick={() => {
                            handleCancelImage("pan");
                          }}
                        />
                      </div>
                    ) : (
                      <ImageandFileUploader
                        is_multiple={false}
                        folder="franchise"
                        name_merge="FRANCHISE_PAN"
                        imageUrl={panUrl}
                        setImageUrl={setPanUrl}
                        no_of_image={1}
                        acceptType="application/pdf, image/jpeg, image/jpg, image/png"
                      />
                    )}

                    <Error errorName={errors.panUrl} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label={"GST No  (Optional)"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      required={false}
                      label="GST No"
                      name="gst_number"
                      type="text"
                      placeholder={"22AAAAA0000A1Z5"}
                      pattern={
                        /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[0-9]{1}[Z]{1}[A-Z\d]{1}$/
                      }
                    />
                    <Error errorName={errors.gst_number} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea label={"GST Certificate (Optional)"} />

                    {gstUrl ? (
                      <div className="flex items-center gap-3">
                        {isPdfFile(gstUrl) ? (
                          <a
                            href={process.env.REACT_APP_API_IMAGE_URL + gstUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-4 py-3 border rounded-md text-blue-600 hover:bg-blue-50"
                          >
                            📄 View GST PDF
                          </a>
                        ) : isImageFile(gstUrl) ? (
                          <img
                            style={{
                              objectFit: "cover",
                              width: "250px",
                              borderRadius: "10px",
                              height: "100px",
                              cursor: "pointer",
                            }}
                            src={process.env.REACT_APP_API_IMAGE_URL + gstUrl}
                            alt="GST Certificate"
                            onClick={() =>
                              openZoomModal(
                                process.env.REACT_APP_API_IMAGE_URL + gstUrl,
                              )
                            }
                          />
                        ) : (
                          <a
                            href={process.env.REACT_APP_API_IMAGE_URL + gstUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline"
                          >
                            📎 View File
                          </a>
                        )}

                        <FiX
                          size={25}
                          className="cursor-pointer"
                          onClick={() => {
                            handleCancelImage("gst");
                          }}
                        />
                      </div>
                    ) : (
                      <ImageandFileUploader
                        is_multiple={false}
                        folder="franchise"
                        name_merge="FRANCHISE_GST"
                        imageUrl={gstUrl}
                        setImageUrl={setGstUrl}
                        no_of_image={1}
                        acceptType="application/pdf, image/jpeg, image/jpg, image/png"
                      />
                    )}

                    <Error errorName={errors.gstUrl} />
                  </div>
                </div>

                <DrawerPreviousNext
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
              </>
            )}
            {step === 4 && (
              <>
                <div className="grid grid-cols-12 gap-4 mb-6">
                  <div className="col-span-6">
                    <LabelArea required label={"Bank Name"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Bank Name"
                      name="bank_name"
                      type="text"
                      minLength={3}
                      placeholder={"xyz bank"}
                      pattern={/^[A-Za-z. ]+$/}
                    />
                    <Error errorName={errors.bank_name} />
                  </div>
                  <div className="col-span-6">
                    <LabelArea required label={"Account Number"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Account Number"
                      name="account_number"
                      type="text"
                      placeholder={"635802010014976"}
                      pattern={/^\d{5,18}$/}
                    />
                    <Error errorName={errors.account_number} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"Beneficiary Name"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Beneficiary Name"
                      name="beneficiary_name"
                      type="text"
                      minLength={3}
                      placeholder={"Jhon"}
                      pattern={/^[A-Za-z. ]+$/}
                    />
                    <Error errorName={errors.beneficiary_name} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"IFSC Code"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="IFSC Code"
                      name="ifsc_code"
                      type="text"
                      capitalize={true}
                      placeholder={"SBIN0005943"}
                      pattern={/^[A-Z]{4}[A-Z0-9]{7}$/i}
                      maxLength={11}
                    />
                    <Error errorName={errors.ifsc_code} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea required label={"Canceled Check Leaf"} />

                    {checkLeafUrl ? (
                      <div className="flex items-center gap-3">
                        {isPdfFile(checkLeafUrl) ? (
                          <a
                            href={
                              process.env.REACT_APP_API_IMAGE_URL + checkLeafUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-4 py-3 border rounded-md text-blue-600 hover:bg-blue-50"
                          >
                            📄 View Check Leaf PDF
                          </a>
                        ) : isImageFile(checkLeafUrl) ? (
                          <img
                            style={{
                              objectFit: "cover",
                              width: "250px",
                              borderRadius: "10px",
                              height: "100px",
                              cursor: "pointer",
                            }}
                            src={
                              process.env.REACT_APP_API_IMAGE_URL + checkLeafUrl
                            }
                            alt="Canceled Check Leaf"
                            onClick={() =>
                              openZoomModal(
                                process.env.REACT_APP_API_IMAGE_URL +
                                  checkLeafUrl,
                              )
                            }
                          />
                        ) : (
                          <a
                            href={
                              process.env.REACT_APP_API_IMAGE_URL + checkLeafUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline"
                          >
                            📎 View File
                          </a>
                        )}

                        <FiX
                          size={25}
                          className="cursor-pointer"
                          onClick={() => {
                            handleCancelImage("check");
                          }}
                        />
                      </div>
                    ) : (
                      <ImageandFileUploader
                        is_multiple={false}
                        folder="franchise"
                        name_merge="FRANCHISE_CheckLeaf"
                        imageUrl={checkLeafUrl}
                        setImageUrl={setCheckLeafUrl}
                        no_of_image={1}
                        acceptType="application/pdf, image/jpeg, image/jpg, image/png"
                      />
                    )}

                    <Error errorName={errors.checkLeafUrl} />
                  </div>
                </div>

                <DrawerPreviousSubmit
                  isSubmitting={loading}
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
              </>
            )}
          </div>

          {isModalOpen && (
            <div
              className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
              onClick={(e) => {
                // Close modal if clicking on the backdrop
                if (e.target === e.currentTarget) {
                  closeZoomModal();
                }
              }}
            >
              <div className="bg-white dark:bg-gray-600 p-4 rounded-lg max-w-md w-full relative">
                <button
                  onClick={closeZoomModal}
                  className="viewModelBoxCloseBtn bg-white dark:bg-gray-600 dark:text-white absolute top-2 right-2 text-2xl"
                >
                  <IoIosClose />
                </button>

                <img
                  src={selectedImage}
                  alt="Selected image"
                  className="w-full h-auto rounded-lg"
                />
              </div>
            </div>
          )}

          {/* <DrawerButton id={id} title='Submit'/> */}
        </form>
      </Scrollbars>
    </>
  );
};

export default FranchiseDrawer;
